<template>
  <div class="goods-create">
    <div class="goods-create__header">
      <game-selector :selectedGame="selectedGame" @select="onGameSelect" />
      <div class="goods-create__header__controls">
        <primary-button to="/goods">Goods List</primary-button>
      </div>
    </div>

    <goods-create-form
      :key="selectedGame"
      :selectedGame="selectedGame"
      :loading="loading"
      @submit="onSubmit"
      @cancel="onCancel"
      ref="createForm"
    />
  </div>
</template>

<script>
import GameSelector from '../../../components/ui/GameSelector/GameSelector.vue'
import PrimaryButton from '../../../components/ui/PrimaryButton/PrimaryButton.vue'
import GoodsCreateForm from '../../../components/GoodsCreateForm/GoodsCreateForm.vue'
import { Games } from '@/constants'
import { createGoods } from '@/apis'

export default {
  name: 'GoodsCreateView',
  components: { GameSelector, PrimaryButton, GoodsCreateForm },
  data() {
    return {
      selectedGame: Games.ADOPTME,
      loading: false
    }
  },
  methods: {
    onGameSelect({ game }) {
      this.selectedGame = game
    },
    async onSubmit(requestData) {
      this.loading = true
      try {
        await createGoods(this.selectedGame, requestData)

        this.$toast?.success('Товар успешно создан!')
        this.$router.push('/goods')
      } catch (error) {
        this.$refs.createForm.generalError = 'Ошибка при создании товара. Попробуйте еще раз.'
      } finally {
        this.loading = false
      }
    },
    onCancel() {
      this.$router.push('/goods')
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-create {
  display: flex;
  flex-direction: column;
  gap: 15px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
